// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__28KVr","left":"InfoRow_left__3ONSf"};